//types del form
export const FORM_VALIDATION = 'FORM_VALIDATION';
export const TOTAL_FED_LOANS = 'TOTAL_FED_LOANS';
export const TOTAL_GRANTS_SCHOLARSHIPS = 'TOTAL_GRANTS_SCHOLARSHIPS';
export const TOTAL_COST = 'TOTAL_COST';
export const SEND_FORM = 'SEND_FORM';
export const WORK_STUDY = 'WORK_STUDY';
export const ATTENDANCE_STATE = 'ATTENDANCE_STATE';
